import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { Button, Modal } from 'antd';

import { setStep } from '../../reduxStore/actions/action';
import { CaretLeftOutlined } from '@ant-design/icons';
import { Player } from '@lottiefiles/react-lottie-player';


function Certificate({ userDetails, setStep, utilAssets }) {
    const certificateRef = useRef();
    const [isDownloaded, setIsDownloaded] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        const preloadImages = [utilAssets?.downloadIcon, utilAssets?.certificateImg];
        let loadedImagesCount = 0;

        preloadImages.forEach(src => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                loadedImagesCount += 1;
                if (loadedImagesCount === preloadImages.length) {
                    setImagesLoaded(true);
                }
            };
        });
    }, []);

    const Downloaded = () => {
        return (
            <Modal
                open={isDownloaded}
                onCancel={() => setIsDownloaded(false)}
                footer={null}
                closeIcon={false}
                className='token-model'
                maskClosable={false}
            >
                <div className="r-c-c" style={{ width: "100%", height: "100dvh" }}>
                    <div className='r-c-c' style={{ width: "100%", height: "100%" }}>
                        <img src={utilAssets?.modalBg} className='full-img' alt="Modal Background" />
                    </div>
                    <div className='r-c-c-c' style={{ position: "absolute" }}>
                        <div style={{ fontSize: 30, fontWeight: "bolder", width: "70%", textAlign: "center" }}>
                            Certificate successfully downloaded
                        </div>
                        <div className='r-c-c play-btn m-t-10'>
                            <Button onClick={() => { setStep(7); setIsDownloaded(false) }}>OK</Button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };


    const downloadPDF = () => {
        const input = certificateRef.current;
        const imageUrl = utilAssets?.certificateImg;

        fetch(imageUrl)
            .then(response => response.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);

                html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdfWidth = canvas.width / 2;
                    const pdfHeight = canvas.height / 2;

                    const pdf = new jsPDF('landscape', undefined, [pdfWidth, pdfHeight]);
                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                    pdf.save('SeTu_Certificate.pdf');

                    setIsDownloaded(true);

                    // Revoke the URL to release memory
                    URL.revokeObjectURL(url);
                });
            })
            .catch(error => {
                console.error('Error fetching image:', error);
            });
    };


    const certificationTextFromBackend = utilAssets?.certificateText;
    const userName = userDetails?.name || 'User'; // Default to 'User' if name is not available

    // Replace placeholder with the actual user name
    const certificationNewText = certificationTextFromBackend.replace('{userName}', userName);

    return (
        <div className='r-c-c-c' style={{ width: "100%", height: "100%" }}>
            {/* <div style={{ position: "absolute", zIndex: 10, top: "7%", left: "5%" }}><CaretLeftOutlined onClick={() => setStep(5)} style={{ fontSize: 50 }} /></div> */}

            <div className="r-c-c-c cert-title">
                Congratulations! <span >Here is your certificate of achievement</span>
            </div>
            {/* <div className="cert-download-ic" onClick={downloadPDF}>
                <img className='full-img' src={utilAssets?.downloadIcon} alt="Download" title="Download now" />
            </div> */}
            {imagesLoaded && (
                <div ref={certificateRef} className='parent-certificate r-c-c-c'>
                    <div className="cert-text">
                        {certificationNewText.split('$').map((part, index) => (
                            <React.Fragment key={index}>
                                {index % 2 === 0 ? part : <strong>{part}</strong>}
                                <br />
                            </React.Fragment>
                        ))}
                    </div>
                    <div className='cert-img'>
                        <img className='full-img' src={utilAssets?.certificateImg} alt="Certificate" />
                    </div>
                </div>
            )}
            <div className="r-c-c m-t-15 done-btn-learning " style={{ position: "absolute", bottom: "8%" }}><Button style={{ minWidth: "8vw", minHeight: "5vh", borderRadius: 30 }} onClick={downloadPDF}>DOWNLOAD</Button></div>

            {isDownloaded && <Downloaded />}

            <Player
                autoplay
                loop
                src="https://lottie.host/f691aa16-5563-463e-9a8b-88a348c49c5b/94hZfXseSw.json"
                className="lottie-animation"
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    const { userDetails, utilAssets } = state?.SeTu;
    return { userDetails, utilAssets };
};

const mapDispatchToProps = (dispatch) => ({
    setStep: (val) => dispatch(setStep(val))
});

export default connect(mapStateToProps, mapDispatchToProps)(Certificate);
